import { planSections } from './buy/india/plans';
import type { PerformanceLabPlan } from './buy/india/types';

const diagnosticsSection = planSections.find((s) => s.id === 'diagnostics');

if (!diagnosticsSection) {
  throw new Error('Diagnostics plan section not found in planSections');
}

export const LANDING_DIAGNOSTIC_PLANS: readonly PerformanceLabPlan[] =
  diagnosticsSection.plans;

export const FEATURED_PLAN_ID = 'diagnostics-pro';

export const LANDING_COMPARE_HEADERS = diagnosticsSection.compareHeaders ?? [];

export const LANDING_COMPARE_DATA = diagnosticsSection.compareData ?? [];

const recoverySection = planSections.find((s) => s.id === 'recovery');

if (!recoverySection) {
  throw new Error('Recovery plan section not found in planSections');
}

export const LANDING_RECOVERY_PLANS: readonly PerformanceLabPlan[] =
  recoverySection.plans;

export const RECOVERY_FEATURED_PLAN_ID = 'recovery-month-pass';

export const LANDING_RECOVERY_COMPARE_HEADERS =
  recoverySection.compareHeaders ?? [];

export const LANDING_RECOVERY_COMPARE_DATA = recoverySection.compareData ?? [];

export type PlansSectionVariant = 'diagnostics' | 'recovery' | 'glp';
